import React, { useState, useEffect } from 'react';
import { Box, Typography, Paper, Grid, ToggleButton, ToggleButtonGroup, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText, useMediaQuery, useTheme } from '@mui/material';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '@mui/material';

// Move the constant outside and export it
export const DEFAULT_POSITION_RANGES = {
  'UTG': {
    raisePercentage: '10.1%',
    foldPercentage: '89.9%',
    coloredCells: {
      // Premium pairs
      'AA': '#ff4444',
      'KK': '#ff4444',
      'QQ': '#ff4444',
      'JJ': '#ff4444',
      'TT': '#ff4444',
      '99': '#ff4444',
      '88': '#ff4444',
      '77': '#ff4444',
      '66': '#ff4444',
      
      // Premium suited
      'AKs': '#ff4444',
      'AQs': '#ff4444',
      'AJs': '#ff4444',
      'ATs': '#ff4444',
      'A9s': '#ff4444',
      'A5s': '#ff4444',
      'KQs': '#ff4444',
      'KJs': '#ff4444',
      'KTs': '#ff4444',
      'QJs': '#ff4444',
      'QTs': '#ff4444',
      'JTs': '#ff4444',
      'T9s': '#ff4444',
      '98s': '#ff4444',
      
      // Premium offsuit
      'AKo': '#ff4444',
      'AQo': '#ff4444'
    }
  },
  'UTG+1': {
    raisePercentage: '13.2%',
    foldPercentage: '86.8%',
    coloredCells: {
      // Premium pairs
      'AA': '#ff4444',
      'KK': '#ff4444',
      'QQ': '#ff4444',
      'JJ': '#ff4444',
      'TT': '#ff4444',
      '99': '#ff4444',
      '88': '#ff4444',
      '77': '#ff4444',
      '66': '#ff4444',
      
      // Premium suited
      'AKs': '#ff4444',
      'AQs': '#ff4444',
      'AJs': '#ff4444',
      'ATs': '#ff4444',
      'A9s': '#ff4444',
      'A8s': '#ff4444',
      'A7s': '#ff4444',
      'A6s': '#ff4444',
      'A5s': '#ff4444',
      'A4s': '#ff4444',
      'KQs': '#ff4444',
      'KJs': '#ff4444',
      'KTs': '#ff4444',
      'K9s': '#ff4444',
      'QJs': '#ff4444',
      'QTs': '#ff4444',
      'Q9s': '#ff4444',
      'JTs': '#ff4444',
      'J9s': '#ff4444',
      'T9s': '#ff4444',
      '98s': '#ff4444',
      '87s': '#ff4444',
      
      // Premium offsuit
      'AKo': '#ff4444',
      'AQo': '#ff4444',
      'AJo': '#ff4444',
      'KQo': '#ff4444'
    }
  },
  'UTG+2': {
    raisePercentage: '15.8%',
    foldPercentage: '84.2%',
    coloredCells: {
      // Premium pairs
      'AA': '#ff4444',
      'KK': '#ff4444',
      'QQ': '#ff4444',
      'JJ': '#ff4444',
      'TT': '#ff4444',
      '99': '#ff4444',
      '88': '#ff4444',
      '77': '#ff4444',
      '66': '#ff4444',
      '55': '#ff4444',
      
      // Premium suited
      'AKs': '#ff4444',
      'AQs': '#ff4444',
      'AJs': '#ff4444',
      'ATs': '#ff4444',
      'A9s': '#ff4444',
      'A8s': '#ff4444',
      'A7s': '#ff4444',
      'A6s': '#ff4444',
      'A5s': '#ff4444',
      'A4s': '#ff4444',
      'A3s': '#ff4444',
      'A2s': '#ff4444',
      'KQs': '#ff4444',
      'KJs': '#ff4444',
      'KTs': '#ff4444',
      'K9s': '#ff4444',
      'QJs': '#ff4444',
      'QTs': '#ff4444',
      'Q9s': '#ff4444',
      'JTs': '#ff4444',
      'J9s': '#ff4444',
      'T9s': '#ff4444',
      '98s': '#ff4444',
      '87s': '#ff4444',
      '76s': '#ff4444',
      
      // Premium offsuit
      'AKo': '#ff4444',
      'AQo': '#ff4444',
      'AJo': '#ff4444',
      'KQo': '#ff4444'
    }
  },
  'LOJACK': {
    raisePercentage: '17.5%',
    foldPercentage: '82.5%',
    coloredCells: {
      // Premium pairs
      'AA': '#ff4444',
      'KK': '#ff4444',
      'QQ': '#ff4444',
      'JJ': '#ff4444',
      'TT': '#ff4444',
      '99': '#ff4444',
      '88': '#ff4444',
      '77': '#ff4444',
      '66': '#ff4444',
      '55': '#ff4444',
      '44': '#ff4444',
      
      // Premium suited
      'AKs': '#ff4444',
      'AQs': '#ff4444',
      'AJs': '#ff4444',
      'ATs': '#ff4444',
      'A9s': '#ff4444',
      'A8s': '#ff4444',
      'A7s': '#ff4444',
      'A6s': '#ff4444',
      'A5s': '#ff4444',
      'A4s': '#ff4444',
      'A3s': '#ff4444',
      'A2s': '#ff4444',
      'KQs': '#ff4444',
      'KJs': '#ff4444',
      'KTs': '#ff4444',
      'K9s': '#ff4444',
      'QJs': '#ff4444',
      'QTs': '#ff4444',
      'Q9s': '#ff4444',
      'JTs': '#ff4444',
      'J9s': '#ff4444',
      'T9s': '#ff4444',
      '98s': '#ff4444',
      '87s': '#ff4444',
      '76s': '#ff4444',
      '65s': '#ff4444',
      
      // Premium offsuit
      'AKo': '#ff4444',
      'AQo': '#ff4444',
      'AJo': '#ff4444',
      'ATo': '#ff4444',
      'KQo': '#ff4444',
      'KJo': '#ff4444'
    }
  },
  'HIJACK': {
    raisePercentage: '20.1%',
    foldPercentage: '79.9%',
    coloredCells: {
      // Premium pairs
      'AA': '#ff4444',
      'KK': '#ff4444',
      'QQ': '#ff4444',
      'JJ': '#ff4444',
      'TT': '#ff4444',
      '99': '#ff4444',
      '88': '#ff4444',
      '77': '#ff4444',
      '66': '#ff4444',
      '55': '#ff4444',
      '44': '#ff4444',
      '33': '#ff4444',
      '22': '#ff4444',
      
      // Premium suited
      'AKs': '#ff4444',
      'AQs': '#ff4444',
      'AJs': '#ff4444',
      'ATs': '#ff4444',
      'A9s': '#ff4444',
      'A8s': '#ff4444',
      'A7s': '#ff4444',
      'A6s': '#ff4444',
      'A5s': '#ff4444',
      'A4s': '#ff4444',
      'A3s': '#ff4444',
      'A2s': '#ff4444',
      'KQs': '#ff4444',
      'KJs': '#ff4444',
      'KTs': '#ff4444',
      'K9s': '#ff4444',
      'K8s': '#ff4444',
      'QJs': '#ff4444',
      'QTs': '#ff4444',
      'Q9s': '#ff4444',
      'JTs': '#ff4444',
      'J9s': '#ff4444',
      'T9s': '#ff4444',
      'T8s': '#ff4444',
      '98s': '#ff4444',
      '97s': '#ff4444',
      '87s': '#ff4444',
      '76s': '#ff4444',
      '65s': '#ff4444',
      '54s': '#ff4444',
      
      // Premium offsuit
      'AKo': '#ff4444',
      'AQo': '#ff4444',
      'AJo': '#ff4444',
      'ATo': '#ff4444',
      'KQo': '#ff4444',
      'KJo': '#ff4444',
      'QJo': '#ff4444'
    }
  },
  'CUTOFF': {
    raisePercentage: '25.6%',
    foldPercentage: '74.4%',
    coloredCells: {
      // Premium pairs
      'AA': '#ff4444',
      'KK': '#ff4444',
      'QQ': '#ff4444',
      'JJ': '#ff4444',
      'TT': '#ff4444',
      '99': '#ff4444',
      '88': '#ff4444',
      '77': '#ff4444',
      '66': '#ff4444',
      '55': '#ff4444',
      '44': '#ff4444',
      '33': '#ff4444',
      '22': '#ff4444',
      
      // Premium suited
      'AKs': '#ff4444',
      'AQs': '#ff4444',
      'AJs': '#ff4444',
      'ATs': '#ff4444',
      'A9s': '#ff4444',
      'A8s': '#ff4444',
      'A7s': '#ff4444',
      'A6s': '#ff4444',
      'A5s': '#ff4444',
      'A4s': '#ff4444',
      'A3s': '#ff4444',
      'A2s': '#ff4444',
      'KQs': '#ff4444',
      'KJs': '#ff4444',
      'KTs': '#ff4444',
      'K9s': '#ff4444',
      'K8s': '#ff4444',
      'K7s': '#ff4444',
      'QJs': '#ff4444',
      'QTs': '#ff4444',
      'Q9s': '#ff4444',
      'Q8s': '#ff4444',
      'JTs': '#ff4444',
      'J9s': '#ff4444',
      'J8s': '#ff4444',
      'T9s': '#ff4444',
      'T8s': '#ff4444',
      '98s': '#ff4444',
      '97s': '#ff4444',
      '87s': '#ff4444',
      '86s': '#ff4444',
      '76s': '#ff4444',
      '75s': '#ff4444',
      '65s': '#ff4444',
      '64s': '#ff4444',
      '54s': '#ff4444',
      '43s': '#ff4444',
      
      // Premium offsuit
      'AKo': '#ff4444',
      'AQo': '#ff4444',
      'AJo': '#ff4444',
      'ATo': '#ff4444',
      'A9o': '#ff4444',
      'KQo': '#ff4444',
      'KJo': '#ff4444',
      'KTo': '#ff4444',
      'QJo': '#ff4444',
      'QTo': '#ff4444',
      'JTo': '#ff4444'
    }
  },
  'BUTTON': {
    raisePercentage: '45.2%',
    foldPercentage: '54.8%',
    coloredCells: {
      // All pairs
      'AA': '#ff4444',
      'KK': '#ff4444',
      'QQ': '#ff4444',
      'JJ': '#ff4444',
      'TT': '#ff4444',
      '99': '#ff4444',
      '88': '#ff4444',
      '77': '#ff4444',
      '66': '#ff4444',
      '55': '#ff4444',
      '44': '#ff4444',
      '33': '#ff4444',
      '22': '#ff4444',
      
      // All suited Ax
      'AKs': '#ff4444',
      'AQs': '#ff4444',
      'AJs': '#ff4444',
      'ATs': '#ff4444',
      'A9s': '#ff4444',
      'A8s': '#ff4444',
      'A7s': '#ff4444',
      'A6s': '#ff4444',
      'A5s': '#ff4444',
      'A4s': '#ff4444',
      'A3s': '#ff4444',
      'A2s': '#ff4444',
      
      // All suited Kx
      'KQs': '#ff4444',
      'KJs': '#ff4444',
      'KTs': '#ff4444',
      'K9s': '#ff4444',
      'K8s': '#ff4444',
      'K7s': '#ff4444',
      'K6s': '#ff4444',
      'K5s': '#ff4444',
      'K4s': '#ff4444',
      'K3s': '#ff4444',
      'K2s': '#ff4444',
      
      // All suited Qx specified
      'QJs': '#ff4444',
      'QTs': '#ff4444',
      'Q9s': '#ff4444',
      'Q8s': '#ff4444',
      'Q7s': '#ff4444',
      'Q6s': '#ff4444',
      'Q5s': '#ff4444',
      'Q4s': '#ff4444',
      'Q3s': '#ff4444',
      'Q2s': '#ff4444',
      
      // All suited Jx specified
      'JTs': '#ff4444',
      'J9s': '#ff4444',
      'J8s': '#ff4444',
      'J7s': '#ff4444',
      'J6s': '#ff4444',
      
      // All suited Tx specified
      'T9s': '#ff4444',
      'T8s': '#ff4444',
      'T7s': '#ff4444',
      'T6s': '#ff4444',
      
      // Other suited connectors and gappers
      '98s': '#ff4444',
      '97s': '#ff4444',
      '96s': '#ff4444',
      '87s': '#ff4444',
      '86s': '#ff4444',
      '85s': '#ff4444',
      '76s': '#ff4444',
      '75s': '#ff4444',
      '74s': '#ff4444',
      '65s': '#ff4444',
      '64s': '#ff4444',
      '54s': '#ff4444',
      '53s': '#ff4444',
      '43s': '#ff4444',
      '32s': '#ff4444',
      
      // All offsuit broadways and specified hands
      'AKo': '#ff4444',
      'AQo': '#ff4444',
      'AJo': '#ff4444',
      'ATo': '#ff4444',
      'A9o': '#ff4444',
      'A8o': '#ff4444',
      'A7o': '#ff4444',
      'A6o': '#ff4444',
      'A5o': '#ff4444',
      'A4o': '#ff4444',
      'A3o': '#ff4444',
      'A2o': '#ff4444',
      'KQo': '#ff4444',
      'KJo': '#ff4444',
      'KTo': '#ff4444',
      'K9o': '#ff4444',
      'K8o': '#ff4444',
      'K7o': '#ff4444',
      'QJo': '#ff4444',
      'QTo': '#ff4444',
      'Q9o': '#ff4444',
      'Q8o': '#ff4444',
      'JTo': '#ff4444',
      'J9o': '#ff4444',
      'J8o': '#ff4444',
      'T9o': '#ff4444',
      'T8o': '#ff4444',
      '98o': '#ff4444',
      '97o': '#ff4444',
      '87o': '#ff4444',
      '76o': '#ff4444'
    }
  },
  // ... other positions with their default configurations
};

// Function to create a responsive cell size based on screen width
function useCellSize() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  
  return {
    width: isMobile ? 24 : isTablet ? 28 : 32,
    height: isMobile ? 24 : isTablet ? 28 : 32,
    fontSize: isMobile ? '0.65rem' : isTablet ? '0.75rem' : '0.85rem'
  };
}

const PreflopCharts = () => {
  const { currentUser } = useAuth();
  const [position, setPosition] = useState('UTG');
  const [positionRanges, setPositionRanges] = useState(DEFAULT_POSITION_RANGES);
  const [customColoredCells, setCustomColoredCells] = useState({});
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    title: '',
    message: '',
    action: null
  });
  const cellSize = useCellSize();

  // Load saved ranges when component mounts or user changes
  useEffect(() => {
    const loadSavedRanges = async () => {
      if (!currentUser) return;

      try {
        const rangesRef = doc(db, 'users', currentUser.uid, 'settings', 'preflopRanges');
        const docSnap = await getDoc(rangesRef);
        
        if (docSnap.exists()) {
          setPositionRanges({
            ...DEFAULT_POSITION_RANGES,
            ...docSnap.data()
          });
        }
      } catch (error) {
        console.error('Error loading saved ranges:', error);
      }
    };

    loadSavedRanges();
  }, [currentUser]);

  // Add this useEffect after your other useEffect
  useEffect(() => {
    setCustomColoredCells({}); // Clear custom colors when position changes
  }, [position]);

  // Define positions
  const positions = [
    'UTG',
    'UTG+1',
    'UTG+2',
    'LOJACK',
    'HIJACK',
    'CUTOFF',
    'BUTTON',
    'SMALL BLIND'
  ];

  // Update handlePositionChange
  const handlePositionChange = (event, newPosition) => {
    if (newPosition !== null) {
      setPosition(newPosition);
      setCustomColoredCells({}); // Clear custom colors when position changes
    }
  };

  // Define the hand ranges to match the image exactly
  const ranges = [
    ['AA', 'AKs', 'AQs', 'AJs', 'ATs', 'A9s', 'A8s', 'A7s', 'A6s', 'A5s', 'A4s', 'A3s', 'A2s'],
    ['AKo', 'KK', 'KQs', 'KJs', 'KTs', 'K9s', 'K8s', 'K7s', 'K6s', 'K5s', 'K4s', 'K3s', 'K2s'],
    ['AQo', 'KQo', 'QQ', 'QJs', 'QTs', 'Q9s', 'Q8s', 'Q7s', 'Q6s', 'Q5s', 'Q4s', 'Q3s', 'Q2s'],
    ['AJo', 'KJo', 'QJo', 'JJ', 'JTs', 'J9s', 'J8s', 'J7s', 'J6s', 'J5s', 'J4s', 'J3s', 'J2s'],
    ['ATo', 'KTo', 'QTo', 'JTo', 'TT', 'T9s', 'T8s', 'T7s', 'T6s', 'T5s', 'T4s', 'T3s', 'T2s'],
    ['A9o', 'K9o', 'Q9o', 'J9o', 'T9o', '99', '98s', '97s', '96s', '95s', '94s', '93s', '92s'],
    ['A8o', 'K8o', 'Q8o', 'J8o', 'T8o', '98o', '88', '87s', '86s', '85s', '84s', '83s', '82s'],
    ['A7o', 'K7o', 'Q7o', 'J7o', 'T7o', '97o', '87o', '77', '76s', '75s', '74s', '73s', '72s'],
    ['A6o', 'K6o', 'Q6o', 'J6o', 'T6o', '96o', '86o', '76o', '66', '65s', '64s', '63s', '62s'],
    ['A5o', 'K5o', 'Q5o', 'J5o', 'T5o', '95o', '85o', '75o', '65o', '55', '54s', '53s', '52s'],
    ['A4o', 'K4o', 'Q4o', 'J4o', 'T4o', '94o', '84o', '74o', '64o', '54o', '44', '43s', '42s'],
    ['A3o', 'K3o', 'Q3o', 'J3o', 'T3o', '93o', '83o', '73o', '63o', '53o', '43o', '33', '32s'],
    ['A2o', 'K2o', 'Q2o', 'J2o', 'T2o', '92o', '82o', '72o', '62o', '52o', '42o', '32o', '22']
  ];

  // Add handler for cell clicks
  const handleCellClick = (hand) => {
    setCustomColoredCells(prev => ({
      ...prev,
      [hand]: prev[hand] === '#ff4444' ? '#fff' : '#ff4444'
    }));
  };

  // Function to calculate percentages
  const calculatePercentages = () => {
    const totalPossibleHands = 1326; // 52C2 = 1326 possible hands
    const currentColoredCells = {
      ...positionRanges[position]?.coloredCells,
      ...customColoredCells
    };

    // Count colored (raise) hands, accounting for suited and offsuit hands
    const raiseCount = Object.keys(currentColoredCells).reduce((count, hand) => {
      if (currentColoredCells[hand] === '#ff4444') {
        if (hand.endsWith('s')) { // Suited hands
          count += 4; // 4 possible combinations for suited hands
        } else if (hand.endsWith('o')) { // Offsuit hands
          count += 12; // 12 possible combinations for offsuit hands
        } else { // Pocket pairs
          count += 6; // 6 possible combinations for pocket pairs
        }
      }
      return count;
    }, 0);

    const raisePercentage = ((raiseCount / totalPossibleHands) * 100).toFixed(1);
    const foldPercentage = (100 - parseFloat(raisePercentage)).toFixed(1);

    return {
      raise: `${raisePercentage}%`,
      fold: `${foldPercentage}%`,
      raiseHands: raiseCount,
      foldHands: totalPossibleHands - raiseCount
    };
  };

  // Get current percentages
  const currentStats = calculatePercentages();

  // Update the handleSaveChanges function
  const handleSaveChangesClick = () => {
    setConfirmDialog({
      open: true,
      title: 'Save Changes',
      message: 'Are you sure you want to save your current changes? This will update your training ranges.',
      action: 'save'
    });
  };

  // Update the handleReset function
  const handleResetClick = () => {
    setConfirmDialog({
      open: true,
      title: 'Reset to Default',
      message: 'Are you sure you want to reset to default ranges? This action cannot be undone.',
      action: 'reset'
    });
  };

  // Add confirmation handlers
  const handleConfirm = async () => {
    if (confirmDialog.action === 'save') {
      try {
        const newRanges = {
          ...positionRanges,
          [position]: {
            ...positionRanges[position],
            coloredCells: {
              ...positionRanges[position]?.coloredCells,
              ...customColoredCells
            }
          }
        };

        const rangesRef = doc(db, 'users', currentUser.uid, 'settings', 'preflopRanges');
        await setDoc(rangesRef, newRanges);
        setPositionRanges(newRanges);
        setCustomColoredCells({});
      } catch (error) {
        console.error('Error saving ranges:', error);
      }
    } else if (confirmDialog.action === 'reset') {
      try {
        const newRanges = {
          ...positionRanges,
          [position]: DEFAULT_POSITION_RANGES[position]
        };

        const rangesRef = doc(db, 'users', currentUser.uid, 'settings', 'preflopRanges');
        await setDoc(rangesRef, newRanges);
        setPositionRanges(newRanges);
        setCustomColoredCells({});
      } catch (error) {
        console.error('Error resetting ranges:', error);
      }
    }
    setConfirmDialog({ ...confirmDialog, open: false });
  };

  const handleCancel = () => {
    setConfirmDialog({ ...confirmDialog, open: false });
  };

  // Modify the renderChart function to use responsive cell sizes
  const renderChart = () => {
    const ranks = ['A', 'K', 'Q', 'J', 'T', '9', '8', '7', '6', '5', '4', '3', '2'];
    const coloredCells = positionRanges[position]?.coloredCells || {};
    
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          overflowX: 'auto' // Allow horizontal scrolling on very small screens
        }}
      >
        <Box 
          sx={{ 
            display: 'grid',
            gridTemplateColumns: `repeat(${ranks.length}, ${cellSize.width}px)`,
            gap: 1,
            mb: 2
          }}
        >
          {/* Header row with ranks */}
          {ranks.map(rank => (
            <Box 
              key={`header-${rank}`}
              sx={{ 
                width: cellSize.width, 
                height: cellSize.height,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 'bold',
                fontSize: cellSize.fontSize
              }}
            >
              {rank}
            </Box>
          ))}
          
          {/* Generate the grid */}
          {ranks.map((rowRank, rowIndex) => (
            ranks.map((colRank, colIndex) => {
              // Determine if it's a pair, suited, or offsuit
              let hand;
              if (rowIndex === colIndex) {
                hand = `${rowRank}${colRank}`; // Pair
              } else if (rowIndex < colIndex) {
                hand = `${rowRank}${colRank}s`; // Suited
              } else {
                hand = `${colRank}${rowRank}o`; // Offsuit
              }
              
              const backgroundColor = coloredCells[hand] || 'transparent';
              
              return (
                <Box
                  key={hand}
                  onClick={() => handleCellClick(hand)}
                  sx={{
                    width: cellSize.width,
                    height: cellSize.height,
                    backgroundColor,
                    border: '1px solid',
                    borderColor: 'divider',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    fontSize: cellSize.fontSize,
                    '&:hover': {
                      opacity: 0.8
                    }
                  }}
                >
                  {hand}
                </Box>
              );
            })
          ))}
        </Box>
        
        {/* Position stats */}
        <Box sx={{ mt: 2, display: 'flex', gap: 4, flexWrap: 'wrap', justifyContent: 'center' }}>
          <Typography variant="body2">
            Raise: {positionRanges[position]?.raisePercentage || '0%'}
          </Typography>
          <Typography variant="body2">
            Fold: {positionRanges[position]?.foldPercentage || '100%'}
          </Typography>
        </Box>
      </Box>
    );
  };

  return (
    <Box sx={{ p: { xs: 1, sm: 2, md: 3 } }}>
      <Paper sx={{ p: { xs: 2, sm: 3 }, mb: 3 }}>
        <Typography variant="h5" component="h2" gutterBottom>
          Preflop Range Charts
        </Typography>
        
        <Typography variant="body2" sx={{ mb: 3, color: 'text.secondary' }}>
          Customize your preflop ranges for different positions. Click on a cell to toggle between raise (red) and fold.
        </Typography>
        
        {/* Position selector - make it scrollable on mobile */}
        <Box sx={{ mb: 3, overflowX: 'auto' }}>
          <ToggleButtonGroup
            value={position}
            exclusive
            onChange={handlePositionChange}
            aria-label="Position"
            sx={{ 
              minWidth: { xs: '100%', sm: 'auto' },
              '& .MuiToggleButton-root': {
                px: { xs: 1, sm: 2 },
                py: 1,
                fontSize: { xs: '0.75rem', sm: '0.875rem' }
              }
            }}
          >
            {positions.map((pos) => (
              <ToggleButton 
                key={pos} 
                value={pos}
                sx={{
                  '&.Mui-selected': {
                    bgcolor: 'primary.main',
                    color: 'white',
                    '&:hover': {
                      bgcolor: 'primary.dark'
                    }
                  }
                }}
              >
                {pos === 'LOJACK' ? 'Lojack' : pos}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </Box>
        
        {/* Chart container with responsive padding */}
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'center',
          p: { xs: 0, sm: 1, md: 2 }
        }}>
          {renderChart()}
        </Box>
        
        {/* Action buttons - stack on mobile */}
        <Box sx={{ 
          mt: 3, 
          display: 'flex', 
          justifyContent: 'space-between',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: 2
        }}>
          <Button 
            variant="outlined" 
            onClick={handleResetClick}
            sx={{ width: { xs: '100%', sm: 'auto' } }}
          >
            Reset to Default
          </Button>
          <Button 
            variant="contained" 
            onClick={handleSaveChangesClick}
            sx={{ width: { xs: '100%', sm: 'auto' } }}
          >
            Save Ranges
          </Button>
        </Box>
      </Paper>
      
      {/* Reset confirmation dialog */}
      <Dialog
        open={confirmDialog.open}
        onClose={handleCancel}
      >
        <DialogTitle>{confirmDialog.title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {confirmDialog.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="primary">
            Cancel
          </Button>
          <Button 
            onClick={handleConfirm} 
            color={confirmDialog.action === 'reset' ? 'error' : 'success'} 
            variant="contained"
            autoFocus
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default PreflopCharts; 